import { render, staticRenderFns } from "./JWTVEndCard.vue?vue&type=template&id=1b373fe2&scoped=true"
import script from "./JWTVEndCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./JWTVEndCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JWTVEndCard.vue?vue&type=style&index=0&id=1b373fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b373fe2",
  null
  
)

export default component.exports